import {createThirdwebClient} from "thirdweb";

export const thirdwebAuthClient = createThirdwebClient({
    clientId: import.meta.env.VITE_THIRDWEB_AUTH_CLIENT_ID,
});